"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailValidation = void 0;
var ValidationMethodBase_1 = require("./ValidationMethodBase");
var EmailValidation = /** @class */ (function (_super) {
    __extends(EmailValidation, _super);
    function EmailValidation(settings, commandsExecutor) {
        var _this = _super.call(this, commandsExecutor) || this;
        _this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return _this;
    }
    EmailValidation.prototype.validateInput = function (input, context) {
        if (!input) {
            return this.validResult();
        }
        if (this.emailRegex.test(input.toString().toLowerCase())) {
            return this.validResult();
        }
        else {
            var error = this.getErrorMessage(context, "Value is not a valid email address");
            return this.invalidResult(error);
        }
    };
    return EmailValidation;
}(ValidationMethodBase_1.ValidationMethodBase));
exports.EmailValidation = EmailValidation;
//# sourceMappingURL=EmailValidation.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/journey-services/dist/validations/EmailValidation.js
// module id = 2100
// module chunks = 0